function isIOS() {
  return !!navigator.userAgent.match(/\(i[^]+( U)? CPU.+Mac OS X/)
}

function isWx() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

export { isIOS, isWx }
